module.exports = __webpack_public_path__ + "static/media/sparkLogo.0c6989bd.svg";